import filterConstants from '../constants';

const costslist = () => ({
  id: null,
  name: null,
  type: filterConstants.FILTERS.costslist,
  properties: {
    [filterConstants.PROPERTY.task_name]: '',
    [filterConstants.PROPERTY.gantt_id]: '',
    [filterConstants.PROPERTY.resource_id]: '',
    [filterConstants.PROPERTY.cost_range]: '',
  },
});

export default costslist;
